/**
 * Fraîcheur PAR indicateur.
 *
 * Règle du correctif : le libellé de fraîcheur d'un cours lit l'âge/status PROPRE
 * de cet indicateur (source_timestamp gelé côté backend si la source tombe), et
 * JAMAIS le seul `updated_at` global du snapshot. Un cours figé vieillit donc
 * réellement et bascule tout seul « différé » puis « indisponible », même si le
 * refresh global continue de tourner.
 *
 * Miroir des seuils backend (markets/config.py). Priorité au status/âge fournis
 * par le backend ; repli de calcul côté client si un ancien cache ne les porte pas.
 */

export const FRESH_MAX_SECONDS = 300; // ≤ 5 min → live
export const DELAYED_MAX_SECONDS = 900; // 5–15 min → différé ; au-delà → indisponible

/** Âge en secondes de l'indicateur, ou null si inconnu. */
export function itemAgeSeconds(item) {
  if (!item) return null;
  if (typeof item.ageSeconds === 'number') return item.ageSeconds;
  if (typeof item.age_seconds === 'number') return item.age_seconds;
  return null;
}

/** Statut effectif : 'live' | 'differe' | 'indisponible'. */
export function itemStatus(item) {
  if (!item) return 'indisponible';
  // Vérité backend prioritaire (déjà calculée au fetch).
  if (item.status === 'live' || item.status === 'differe' || item.status === 'indisponible') {
    return item.status;
  }
  // Repli client (ancien cache sans status) : recalcul depuis l'âge propre.
  if ((item.source || 'live') === 'mock') return 'indisponible';
  const age = itemAgeSeconds(item);
  if (age == null) return 'indisponible';
  if (age <= FRESH_MAX_SECONDS) return 'live';
  if (age <= DELAYED_MAX_SECONDS) return 'differe';
  return 'indisponible';
}

/** Libellé humain court, par ligne. */
export function freshnessLabel(item) {
  const status = itemStatus(item);
  if (status === 'live') return 'En direct';
  if (status === 'indisponible') return 'Indisponible';
  // différé
  const age = itemAgeSeconds(item);
  if (age == null) return 'Différé';
  const mins = Math.floor(age / 60);
  return mins >= 1 ? `Différé il y a ${mins} min` : `Différé il y a ${age} s`;
}

/** Tonalité neutre pour le style — le composant mappe vers ses propres classes. */
export function freshnessTone(item) {
  return itemStatus(item); // 'live' | 'differe' | 'indisponible'
}
